import React, { useState, useEffect } from 'react';
import NotificationPopup from './NotificationPopup';

// Module-level adder so non-React polling code (the triggers) can show a popup.
let addPopupFn = null;

// config: { id, count, title, preview?, accent?, glyph, ctaLabel, onView }
// `id` identifies the notification type ('messages' | 'downloads'): re-firing the
// same id replaces that card in place; different ids stack instead of overwriting.
export function showNotificationPopup(config) {
  if (addPopupFn) addPopupFn(config);
}

// Mounted once (in app.js, logged-in block). Self-wraps in .bravo-ds so its
// position:fixed stack floats over legacy Content without waking dormant DS
// rules on un-migrated pages. Renders a top-center vertical stack of popups
// (at most one per id); each re-keys by count so a new arrival restarts its
// entrance animation + auto-dismiss timer.
export default function NotificationPopupHost() {
  const [popups, setPopups] = useState([]);

  useEffect(() => {
    addPopupFn = (config) =>
      setPopups((prev) => {
        const idx = prev.findIndex((p) => p.id === config.id);
        if (idx === -1) return [...prev, config];
        const next = prev.slice();
        next[idx] = config;
        return next;
      });
    return () => { addPopupFn = null; };
  }, []);

  const remove = (id) => setPopups((prev) => prev.filter((p) => p.id !== id));

  if (popups.length === 0) return null;

  return (
    <div className='bravo-ds'>
      <div className='msg-pop-stack'>
        {popups.map((p) => (
          <NotificationPopup
            key={`${p.id}-${p.count}`}
            count={p.count}
            title={p.title}
            preview={p.preview}
            accent={p.accent}
            glyph={p.glyph}
            ctaLabel={p.ctaLabel}
            onView={() => { if (p.onView) p.onView(); remove(p.id); }}
            onClose={() => remove(p.id)}
          />
        ))}
      </div>
    </div>
  );
}
